export default __webpack_public_path__ + "static/char-s-29-ja-21e487df582b17677cc403009ef8a09e.png";